"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var logs_1 = require("@ledgerhq/logs");
var account_1 = require("../../account");
var js_transaction_1 = require("./js-transaction");
var typhonjs_1 = require("@stricahq/typhonjs");
var js_buildTransaction_1 = require("./js-buildTransaction");
/**
 * Returns the maximum possible amount for transaction
 *
 * @param {Object} param - the account, parentAccount and transaction
 */
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var dummyRecipient, a, t, typhonTransaction, error_1, transactionAmount;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (account.type === "TokenAccount") {
                        return [2 /*return*/, account.balance];
                    }
                    dummyRecipient = "addr1qyqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv2t5am";
                    a = (0, account_1.getMainAccount)(account, parentAccount);
                    t = __assign(__assign(__assign({}, (0, js_transaction_1.createTransaction)()), transaction), { recipient: dummyRecipient, 
                        // amount field will not be used to build a transaction when useAllAmount is true
                        amount: new bignumber_js_1.BigNumber(0), useAllAmount: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, js_buildTransaction_1.buildTransaction)(a, t)];
                case 2:
                    typhonTransaction = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    (0, logs_1.log)("cardano-error", "Failed to estimate max spendable: " + String(error_1));
                    return [2 /*return*/, new bignumber_js_1.BigNumber(0)];
                case 4:
                    transactionAmount = typhonTransaction
                        .getOutputs()
                        .filter(function (o) {
                        return !(o.address instanceof typhonjs_1.address.BaseAddress) ||
                            !(o.address.paymentCredential.type === typhonjs_1.types.HashType.ADDRESS) ||
                            o.address.paymentCredential.bipPath === undefined;
                    })
                        .reduce(function (total, o) { return total.plus(o.amount); }, new bignumber_js_1.BigNumber(0));
                    return [2 /*return*/, transactionAmount];
            }
        });
    });
};
exports["default"] = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map